<template>
  <div :class="$style.Container">
    <div :class="$style.Header">团队人数<span>超过20人</span></div>
    <div :class="$style.Title">请扫描下方二维码联系客服</div>
    <img
      :class="$style.Image"
      src="https://static.lingvisions.com/public/1b5182e665e0420dac86e6aa3729ef34.png"
    />
    <div :class="$style.Time">工作<span style="margin-left: 14px">09:30-12:00</span></div>
    <div :class="$style.Time">时间<span style="margin-left: 14px">14:00-19:00</span></div>
  </div>
</template>

<style lang="less" module>
  .Container {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: rgba(40, 40, 40, 1);
    border-radius: 6px;
    padding-bottom: 16px;
  }

  .Header {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 36px;
    border-radius: 6px 6px 0 0;
    font-size: 14px;
    font-weight: 600;
    line-height: 14px;
    color: rgba(255, 255, 255, 0.85);
    background: url('https://static.lingvisions.com/public/e2bc46d771d245d4acbb35f91c305e67.png')
      center / cover no-repeat;

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background: url('https://static.lingvisions.com/public/4ae1583b1d5d4393aead7b83f5a3e613.png')
        center / cover no-repeat;
      background-position: right;
      z-index: 9;
    }

    > span {
      color: rgba(107, 49, 25, 1);
    }
  }

  .Title {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    color: rgba(255, 255, 255, 0.45);
    text-align: center;
    height: 28px;
    margin-top: 8px;
  }

  .Image {
    width: 120px;
    height: 120px;
    margin-top: 8px;
    margin-bottom: 8px;
  }

  .Time {
    color: rgba(255, 255, 255, 0.45);
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
  }
</style>
